/**
 * <lih-sticky-cta> — the mobile View Product bar.
 *
 * It arrives once the hero is behind you and retires for good at the product
 * tabs, where the real buy button already is. Two IntersectionObservers would
 * be two of the same thing, so one watches both edges and the callback reads
 * which target moved.
 *
 * The link itself carries data-lih-open-tab / data-lih-goto-tabs, so
 * <lih-product-tabs> handles the click — there is nothing to wire up here.
 *
 * Markup contract:
 *   <lih-sticky-cta class="lp-live-in-hoops-sticky">
 *     <a class="lp-live-in-hoops-sticky__button" href="…" data-lih-open-tab></a>
 *   </lih-sticky-cta>
 */
class LihStickyCta extends HTMLElement {
  /* Scrolled past this, the bar appears; reaching this one retires it. */
  static AFTER = '.lp-live-in-hoops-hero';
  static UNTIL = 'lih-product-tabs';
  static VISIBLE = 'lp-live-in-hoops-sticky--in';

  connectedCallback() {
    this.after = document.querySelector(LihStickyCta.AFTER);
    this.until = document.querySelector(LihStickyCta.UNTIL);

    /* No hero to scroll past — nothing to wait for. */
    this.passed = !this.after;
    this.reached = false;

    this.observer = new IntersectionObserver(this.onIntersect.bind(this));
    if (this.after) this.observer.observe(this.after);
    if (this.until) this.observer.observe(this.until);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  /* Positions come from the entry rather than the viewport, so a fast scroll
     that skips a whole section still resolves correctly: something is behind
     you once its bottom is above the fold, and reached as soon as its top
     shows — or has already gone by. */
  onIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.target === this.after) {
        this.passed = entry.boundingClientRect.bottom <= 0;
      } else {
        this.reached = entry.isIntersecting || entry.boundingClientRect.top < 0;
      }
    });

    this.classList.toggle(LihStickyCta.VISIBLE, this.passed && !this.reached);
  }
}

if (!customElements.get('lih-sticky-cta')) {
  customElements.define('lih-sticky-cta', LihStickyCta);
}
